import Immutable from 'immutable';

import { VIEW_GET_LOADED } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import { addNewMessage } from '../actions/Messages';

const messagesMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  switch (action.type) {
    case VIEW_GET_LOADED: {
      if (action.viewId !== 'message') {
        return next(action);
      }

      const messages = action.data.entities;
      const previousMessages = getState().getIn(['view', 'message', 'block_1', 'entities'], Immutable.List()).toJS();
      const isInitialLoaded = getState().getIn(['messages', 'isInitialLoaded'], false);

      // Only when the state has fully loaded and we know how many messages
      // were previously in the state, can we check if we have any new message.
      // If we do, add this new message to the state.
      if (isInitialLoaded && messages.length > previousMessages.length) {
        dispatch(addNewMessage(messages[0]));
      }

      break;
    }
  }

  return next(action);
};

export default messagesMiddleware;
